import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActionCenterUnlinkerFactory } from '@app/shared/action-center/actions/data-unlinking-service/factory';
import { IClassificationSuggestions } from '@app/pages/cmms/interfaces/classification.interfaces';
import { ActionCenterService } from '@app/core/services/action-center.service';
import { TableType } from '@app/pages/cmms/types';
import { ActionCenterLinkerFactory } from '@app/shared/action-center/actions/linking/factory';

@Component({
	selector: 'au-classification-suggestion-badge',
	templateUrl: './au-classification-suggestion-badge.component.html',
	styleUrls: ['./au-classification-suggestion-badge.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MatIconModule, CommonModule, MatButtonModule],
})
export class AuClassificationSuggestionBadgeComponent {
	private readonly linkerFactory = inject(ActionCenterLinkerFactory);
	private readonly unlinkerFactory = inject(ActionCenterUnlinkerFactory);
	private readonly actionCenterService = inject(ActionCenterService);

	@Input() suggestions: IClassificationSuggestions[];
	@Input() fileId: string;

	async acceptSuggestion(suggestion: IClassificationSuggestions) {
		await this.linkerFactory
			.createLinker(TableType.FILES, 'classifications')
			.link([this.fileId], [suggestion]);

		await this.unlinkerFactory
			.createUnlinker(TableType.FILES, 'classificationSuggestions')
			.unlink([this.fileId], [suggestion]);

		this.actionCenterService.actionDone$.next();
	}

	async rejectSuggestion(suggestion: IClassificationSuggestions) {
		await this.unlinkerFactory
			.createUnlinker(TableType.FILES, 'classificationSuggestions')
			.unlink([this.fileId], [suggestion]);

		this.actionCenterService.actionDone$.next();
	}
}
